<mat-spinner *ngIf="loading"></mat-spinner>
<div *ngIf="!loading">
  <div class="app-base">
    <mat-chip-list>
      <mat-chip
        *ngFor="let budget of budgets"
        [selected]="isSelected(budget)"
        (click)="setCurrentBudget(budget)"
      >
        {{ getName(budget) }}
        <mat-icon
          (click)="remove(budget)"
          >cancel</mat-icon
        >
      </mat-chip></mat-chip-list
    >
  </div>

  <app-budget-order></app-budget-order>

  <button
    (click)="addBudget()"
    type="button"
    style="z-index: 1000; position: fixed; bottom: 80px; right: 15px"
    mat-fab
    color="primary"
  >
    <mat-icon>add</mat-icon>
  </button>

  <button
    type="button"
    (click)="finish()"
    style="z-index: 1000; position: fixed; bottom: 15px; right: 15px"
    mat-fab
  >
    <mat-icon>done</mat-icon>
  </button>

</div>
